<ui-segmented
  [options]="options()"
  [activeOptionId]="activeOptionId()"
  [ariaLabel]="ariaLabel()"
  (activeOptionIdChange)="handleActiveOptionIdChange($event)"
/>
